// eslint-disable-next-line import/prefer-default-export
export function isMontantValid(montant) {
  if (!montant) return true;

  const min = montant.montantMin;
  const max = montant.montantMax;

  if (min === null && max === null) return true;

  if (min === null || max === null) return true;

  return Number(min) <= Number(max);
}
